import type { ZodUUID } from 'zod/v4';
import { isNil, isNull, isString } from 'lodash';
import { v4, v5 } from 'uuid';

export type Uuid = string & ({ readonly _: unique symbol } | ZodUUID);

export const emptyUuid = stringToUuid('00000000-0000-0000-0000-000000000000');

export function isUuid(value: string): value is Uuid {
    return /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(value);
}

export function isUuidOrNull(value: unknown): boolean {
    return (isString(value) && isUuid(value)) || isNull(value);
}

export function uuidv4(): Uuid {
    return v4() as Uuid;
}

export function uuidv5(value: string, namespace: string): Uuid {
    return v5(value, namespace) as Uuid;
}

export function stringToUuid(uuid: string): Uuid {
    assertIsUuid(uuid);

    return uuid;
}

export function assertIsUuid(uuid: string): asserts uuid is Uuid {
    if (!isUuid(uuid)) {
        throw new Error(`Invalid uuid: ${uuid}`);
    }
}

export function optionalStringToUuid(uuid: string | null | undefined): Uuid | null {
    return isNil(uuid) ? null : stringToUuid(uuid);
}
